// The section about the cost of a cyber attack for small enterprises
const Cost = () => {
	return (
		<section id="cost">
			<header>
				<h3>How much could such an attack COST a small enterprise</h3>
			</header>
			<main className="flex col align-center">
				<svg
					id="Group_15"
					data-name="Group 15"
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					viewBox="0 0 1129 578">
					<g
						id="Rectangle"
						fill="#fff"
						stroke="#979797"
						strokeMiterlimit="10"
						strokeWidth="1">
						<rect width="1129" height="578" rx="4" stroke="none" />
						<rect
							x="0.5"
							y="0.5"
							width="1128"
							height="577"
							rx="3.5"
							fill="none"
						/>
					</g>
					<text
						id="_0"
						data-name="0"
						transform="translate(41 458)"
						fill="#373737"
						fontSize="24"
						fontFamily="Roboto-Regular, Roboto">
						<tspan x="0" y="0">
							$ 0
						</tspan>
					</text>
					<text
						id="_1_mil"
						data-name="1 mil"
						transform="translate(21 358)"
						fill="#373737"
						fontSize="24"
						fontFamily="Roboto-Regular, Roboto">
						<tspan x="0" y="0">
							$ 1mil.
						</tspan>
					</text>
					<text
						id="_2_mil"
						data-name="2 mil"
						transform="translate(21 258)"
						fill="#373737"
						fontSize="24"
						fontFamily="Roboto-Regular, Roboto">
						<tspan x="0" y="0">
							$ 2mil.
						</tspan>
					</text>
					<text
						id="_3_mil"
						data-name="3 mil"
						transform="translate(21 158)"
						fill="#373737"
						fontSize="24"
						fontFamily="Roboto-Regular, Roboto">
						<tspan x="0" y="0">
							$ 3mil.
						</tspan>
					</text>
					<text
						id="_4mil"
						data-name="4mil"
						transform="translate(24 58)"
						fill="#373737"
						fontSize="24"
						fontFamily="Roboto-Regular, Roboto">
						<tspan x="0" y="0">
							$ 4mil.
						</tspan>
					</text>
					<path
						id="Line_8"
						data-name="Line 8"
						d="M.5.5h951"
						transform="translate(119 449)"
						fill="none"
						stroke="#979797"
						strokeLinecap="square"
						strokeMiterlimit="10"
						strokeWidth="1"
					/>
					<path
						id="Line_8_Copy"
						data-name="Line 8 Copy"
						d="M.5.5h951"
						transform="translate(119 349)"
						fill="none"
						stroke="#979797"
						strokeLinecap="square"
						strokeMiterlimit="10"
						strokeWidth="1"
					/>
					<path
						id="Line_8_Copy_2"
						data-name="Line 8 Copy 2"
						d="M.5.5h951"
						transform="translate(119 249)"
						fill="none"
						stroke="#979797"
						strokeLinecap="square"
						strokeMiterlimit="10"
						strokeWidth="1"
					/>
					<path
						id="Line_8_Copy_3"
						data-name="Line 8 Copy 3"
						d="M.5.5h951"
						transform="translate(119 149)"
						fill="none"
						stroke="#979797"
						strokeLinecap="square"
						strokeMiterlimit="10"
						strokeWidth="1"
					/>
					<path
						id="Line_8_Copy_4"
						data-name="Line 8 Copy 4"
						d="M.5.5h951"
						transform="translate(119 49)"
						fill="none"
						stroke="#979797"
						strokeLinecap="square"
						strokeMiterlimit="10"
						strokeWidth="1"
					/>
					<g
						id="Group_11"
						data-name="Group 11"
						transform="translate(774 173.453)">
						<text
							id="Cloud_misconfigurati"
							data-name="Cloud misconfigurati"
							transform="translate(0 327)"
							fill="#373737"
							fontSize="24"
							fontFamily="Roboto-Regular, Roboto">
							<tspan x="0" y="23">
								Cloud misconfiguration
							</tspan>
						</text>
						<g
							id="Group_10_Copy_2"
							data-name="Group 10 Copy 2"
							transform="translate(80)">
							<rect
								id="Rectangle-2"
								data-name="Rectangle"
								width="88"
								height="277"
								fill="#eb5757"
							/>
							<text
								id="_2.7"
								data-name="2.7"
								transform="translate(25 120)"
								fill="#fff"
								fontSize="24"
								fontFamily="Roboto-Bold, Roboto"
								fontWeight="700">
								<tspan x="0" y="23">
									2.7
								</tspan>
							</text>
						</g>
					</g>
					<g
						id="Group_12"
						data-name="Group 12"
						transform="translate(558 125.453)">
						<text
							id="Phishing"
							transform="translate(0 374)"
							fill="#373737"
							fontSize="24"
							fontFamily="Roboto-Regular, Roboto">
							<tspan x="0" y="23">
								Phishing
							</tspan>
						</text>
						<g id="Group_10" data-name="Group 10">
							<g id="Group_14" data-name="Group 14">
								<rect
									id="Rectangle-3"
									data-name="Rectangle"
									width="88"
									height="324"
									fill="#eb5757"
								/>
								<text
									id="_3.25"
									data-name="3.25"
									transform="translate(19 133.412)"
									fill="#fff"
									fontSize="24"
									fontFamily="Roboto-Bold, Roboto"
									fontWeight="700">
									<tspan x="0" y="23">
										3.25
									</tspan>
								</text>
							</g>
						</g>
					</g>
					<g
						id="Group_13"
						data-name="Group 13"
						transform="translate(169 149.453)">
						<text
							id="Compromied_Credentia"
							data-name="Compromied Credentia"
							transform="translate(0 350)"
							fill="#373737"
							fontSize="24"
							fontFamily="Roboto-Regular, Roboto">
							<tspan x="0" y="23">
								Compromied Credentials
							</tspan>
						</text>
						<g
							id="Group_10_Copy"
							data-name="Group 10 Copy"
							transform="translate(89)">
							<rect
								id="Rectangle-4"
								data-name="Rectangle"
								width="88"
								height="300"
								fill="#eb5757"
							/>
							<text
								id="_3.0"
								data-name="3.0"
								transform="translate(26 132)"
								fill="#fff"
								fontSize="24"
								fontFamily="Roboto-Bold, Roboto"
								fontWeight="700">
								<tspan x="0" y="23">
									3.0
								</tspan>
							</text>
						</g>
					</g>
				</svg>
			</main>
			<footer>
				<p>
					Costs shown are taken from IBMs annual Cost-of-Data-Breach report and
					have been scaled down to better represent small enterprises.(avg.
					small-enterprises / overall avg. = (2.98/4.24) = 70%) Source:{' '}
					<a
						className="sourcelink"
						href="https://www.ibm.com/security/data-breach">
						IBM CoDB 2021
					</a>
				</p>
			</footer>
		</section>
	);
};

export { Cost };
